import * as React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import CommunicationHead from './CommunicationHead';
import GetCommunicationData from './GetCommunicationData';

import State from '../../interfaces/states/State';

import CommunicationData from '../../interfaces/CommunicationData';

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
});

interface Props {
  communicationData: CommunicationData;
  classes: any;
}

const CommunicationExpansionPanel = ({ classes, communicationData }: Props) => {

  const [isOpen, setOpen] = React.useState(true);

  const onExpansionChange = React.useCallback(() => setOpen(!isOpen), [isOpen]);

  return (
    <div className={classes.root}>
      <ExpansionPanel
        onChange={onExpansionChange}
        expanded={isOpen}
        className='communication-expans' >
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.heading}>
            {'Current e-mail statuses'}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ padding: '0px' }}>
          <div className='communication-table'>
            <CommunicationHead currentMail />
            <GetCommunicationData
              currentMail
              communicationData={communicationData} />
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel
        onChange={onExpansionChange}
        expanded={!isOpen}
        className='communication-expans'>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.heading}>
            {'E-mails history'}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ padding: '0px' }}>
          <div className='communication-table'>
            <CommunicationHead currentMail={false} />
            <GetCommunicationData
              currentMail={false}
              communicationData={communicationData} />
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    communicationData: state.communication.communicationData,
  };
};

export default connect(
  mapStateToProps, {})(withStyles(styles)(CommunicationExpansionPanel));
